export default "__VITE_ASSET__BI0XWeW6__"